import React from 'react';

import classes from './CloneQuizForm.module.css';

import FlexModal from '../../UI/FlexModal/FlexModal';
import IconButton from '../../UI/IconButton/IconButton';
import FormFields from '../FormFields';
import Button from '../../UI/Button/Button';

import { IsObjectEmpty, IsStringEmpty, GetObjectClone } from '../../../utilities/CommonMethods';
import Input from '../../UI/Input/Input';

import closeIconBlack from '../../../assets/icons/icon-close-black.png';
import Wrapper from '../../../hoc/Wrapper/Wrapper';
import ShowLoader from '../../../hoc/ShowLoader/ShowLoader';
import { parseDateForInputField, parseTimeForInputField } from '../../../utilities/DateTimeUtils';
import NewInputDropDown from '../../UI/NewInputDropdown/NewInputDropDown';
import ResourceAPIController from '../../../webServices/ResourceAPIController';

class CloneQuizForm extends React.Component {

    state = {
        cloneQuizForm: GetObjectClone(FormFields.cloneQuizForm),
        cloneQuizFormValid: false,
        errorMessage: '',
        showErrorMessage: false,
        showFormErrorMessage: false,
        formErrorMessage: '',
        showToolTip: false,
        inputDropdown: false,
        programList: [],
        moduleList: [],
        activeProgramItem: 0,
        activeModuleItem: 0,
        showInputDropDowns: false,
        showLoader: true,
        isModulesFetched: false,
    }

    checkRemainingCount = (value, inputIdentifier) => {
        var maxLength = this.state.cloneQuizForm[inputIdentifier].totalChar;
        var remainingCount = maxLength - value.length;
        return (remainingCount);
    }

    checkValidity = (formElement) => {
        let isValid = true;

        const rules = formElement.validation;
        let value = formElement.value;
        if (!IsObjectEmpty(formElement.validation)) {
            if (!IsObjectEmpty(rules.required) && rules.required.value) {
                isValid = (value.length > 0) && isValid;
                formElement.errorMessage = isValid ? '' : rules.required.errorMessage;
                formElement.valid = isValid;
            }
        }
        if (!IsObjectEmpty(rules.date)) {
            if (rules.date.value && !IsStringEmpty(value) && formElement.label === 'Start Date') {
                const parsedDate = IsStringEmpty(value) ? '' : new Date(value);
                if (IsStringEmpty(parsedDate)) { // Start Date cannot be empty
                    isValid = false && isValid;
                    formElement.valid = isValid;
                    formElement.errorMessage = isValid ? '' : 'Start date can not be empty';
                }

                let currentDate = new Date();
                let selectedDate = new Date(value + ' 00:00');

                let currentDateString = currentDate.getDate() + '-' + currentDate.getMonth() + '-' + currentDate.getFullYear();
                let selectedDateString = selectedDate.getDate() + '-' + selectedDate.getMonth() + '-' + selectedDate.getFullYear();

                if (!IsStringEmpty(selectedDate.getTime()) && IsObjectEmpty(this.props.data)) {
                    if ((selectedDate.getTime() < currentDate.getTime()) && (selectedDateString !== currentDateString)) {
                        isValid = false && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : 'Previous dates can not be selected.';
                    }
                }
            } else if (formElement.label === 'End Date') {
                const parsedDate = IsStringEmpty(value) ? '' : new Date(value);
                if (IsStringEmpty(parsedDate)) { // End Date cannot be empty
                    isValid = false && isValid;
                    formElement.valid = isValid;
                    formElement.errorMessage = isValid ? '' : 'End date can not be empty';
                }

                let currentDate = new Date();
                let selectedDate = new Date(value + ' 00:00');

                let currentDateString = currentDate.getDate() + '-' + currentDate.getMonth() + '-' + currentDate.getFullYear();
                let selectedDateString = selectedDate.getDate() + '-' + selectedDate.getMonth() + '-' + selectedDate.getFullYear();

                if (!IsStringEmpty(selectedDate.getTime())) {
                    if ((selectedDate.getTime() < currentDate.getTime()) && (selectedDateString !== currentDateString)) {
                        isValid = false && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : 'Previous dates can not be selected.';
                    }
                }
            }
        }

        if (!IsObjectEmpty(rules.startTime)) {
            if (rules.startTime.value && !IsStringEmpty(value)) {
                const startTimeValue = value;
                const startDateValue = this.state.cloneQuizForm['startDate'].value;
                const dueTimeValue = this.state.cloneQuizForm['dueTime'].value;
                const dueDateValue = this.state.cloneQuizForm['dueDate'].value;

                let parsedStartTime = '', parsedDueTime = '';
                if (!IsStringEmpty(startDateValue) && !IsStringEmpty(dueDateValue)) {
                    parsedStartTime = IsStringEmpty(startTimeValue) ? '' : Date.parse(startDateValue + ' ' + startTimeValue);
                    parsedDueTime = IsStringEmpty(dueTimeValue) ? '' : Date.parse(dueDateValue + ' ' + dueTimeValue);
                } else {
                    parsedStartTime = IsStringEmpty(startTimeValue) ? '' : Date.parse('01/01/2021' + startTimeValue);
                    parsedDueTime = IsStringEmpty(dueTimeValue) ? '' : Date.parse('01/01/2021' + dueTimeValue);
                }

                if (!IsStringEmpty(parsedStartTime) && !IsStringEmpty(parsedDueTime)) {
                    if (parsedDueTime < parsedStartTime) {
                        isValid = false && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : 'Start Time can not be larger than End Time';
                        this.state.cloneQuizForm['dueTime'].errorMessage = '';
                    } else if (parsedDueTime > parsedStartTime) {
                        isValid = true && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : '';
                        this.state.cloneQuizForm['dueTime'].valid = true;
                    }

                }
            }
        }
        if (!IsObjectEmpty(rules.dueTime)) {
            if (rules.dueTime.value && !IsStringEmpty(value)) {

                const dueTimeValue = value;
                const dueDateValue = this.state.cloneQuizForm['dueDate'].value;
                const startTimeValue = this.state.cloneQuizForm['startTime'].value;
                const startDateValue = this.state.cloneQuizForm['startDate'].value;

                let parsedStartTime = '', parsedDueTime = '';
                if (!IsStringEmpty(startDateValue) && !IsStringEmpty(dueDateValue)) {
                    parsedStartTime = IsStringEmpty(startTimeValue) ? '' : Date.parse(startDateValue + ' ' + startTimeValue);
                    parsedDueTime = IsStringEmpty(dueTimeValue) ? '' : Date.parse(dueDateValue + ' ' + dueTimeValue);
                } else {
                    parsedStartTime = IsStringEmpty(startTimeValue) ? '' : Date.parse('01/01/2021' + startTimeValue);
                    parsedDueTime = IsStringEmpty(dueTimeValue) ? '' : Date.parse('01/01/2021' + dueTimeValue);
                }

                if (!IsStringEmpty(parsedStartTime) && !IsStringEmpty(parsedDueTime) && !IsStringEmpty(value) && !IsStringEmpty(startTimeValue)) {
                    if (parsedDueTime < parsedStartTime) {
                        isValid = false && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : 'Due Time can not be smaller than Start Time';
                        this.state.cloneQuizForm['startTime'].errorMessage = '';
                    } else if (parsedDueTime > parsedStartTime) {
                        isValid = true && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : '';
                        this.state.cloneQuizForm['startTime'].valid = true;
                    }
                } else if (IsStringEmpty(parsedDueTime)) {
                    isValid = false && isValid;
                    formElement.valid = isValid;
                    formElement.errorMessage = isValid ? '' : 'This is a required field';
                }
            }
        }

        if (!IsObjectEmpty(rules.isPercentage) && rules.isPercentage.value && !IsStringEmpty(value)) {
            if ((isNaN(parseInt(value, 10)) === false) && typeof (parseInt(value, 10)) === 'number') {
                isValid = parseInt(value, 10) > 0 && parseInt(value, 10) < 100;
                formElement.errorMessage = isValid ? '' : rules.isPercentage.errorMessage;
                formElement.valid = isValid;
            } else {
                isValid = parseInt(value, 10) > 0 && isValid;
                formElement.errorMessage = isValid ? '' : rules.isNumber.errorMessage;
                formElement.valid = isValid;
            }

        } else if (!IsObjectEmpty(rules.isNumber) && rules.isNumber.value && !IsStringEmpty(value)) {
            isValid = typeof (parseInt(value, 10)) === 'number' && parseInt(value, 10) > 0 && isValid;
            formElement.errorMessage = isValid ? '' : rules.isNumber.errorMessage;
            formElement.valid = isValid;
        }

        return (formElement);
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = { ...this.state.cloneQuizForm };
        let updatedFormElement = { ...updatedForm[inputIdentifier] };

        let inputValue = event.target.value;

        if (inputIdentifier === 'quizTitle' && updatedFormElement.remainingChar > 0) {
            updatedFormElement.remainingChar = this.checkRemainingCount(event.target.value, inputIdentifier);
            inputValue = event.target.value;
        } else if (inputIdentifier === 'quizTitle' && updatedFormElement.remainingChar <= 0) {
            inputValue = event.target.value.substring(0, updatedFormElement.totalChar)
        } else {
            inputValue = event.target.value;
        }

        updatedFormElement.value = inputValue;
        updatedFormElement.touched = true;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedFormElement.valid = updatedFormElement.valid
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;

        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }

            this.setState({ cloneQuizForm: updatedForm, cloneQuizFormValid: formIsValid });
        }
    }

    onCloneQuizButtonClick = () => {
        const updatedForm = { ...this.state.cloneQuizForm };
        for (let item in updatedForm) {
            updatedForm[item] = this.checkValidity(updatedForm[item], updatedForm);
        }

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }

        let formErrorMessage = '';
        if (formIsValid) {
            const schedule_date = this.state.cloneQuizForm['startDate'].value,
                schedule_time = this.state.cloneQuizForm['startTime'].value,
                due_date = this.state.cloneQuizForm['dueDate'].value,
                due_time = this.state.cloneQuizForm['dueTime'].value;

            const startDate = new Date(schedule_date + ' ' + schedule_time);
            const dueDate = new Date(due_date + ' ' + due_time);

            if (startDate.toLocaleString() === dueDate.toLocaleString()) {
                // formErrorMessage = 'Start Time and Due Time can not be same';
                const dueTimeElement = updatedForm['dueTime'];
                dueTimeElement.valid = false;
                dueTimeElement.errorMessage = 'Due Time and Start Time can not be same';
                updatedForm['dueTime'] = dueTimeElement;
                formIsValid = false;
            } else {
                formErrorMessage = '';
                formIsValid = formIsValid && true;
            }
        }


        this.setState({ cloneQuizForm: updatedForm, cloneQuizFormValid: formIsValid, showFormErrorMessage: !IsStringEmpty(formErrorMessage), formErrorMessage: formErrorMessage });
        if (formIsValid) {

            const moduleName = this.state.moduleList[this.state.activeModuleItem].name,
                batchCode = this.state.programList[this.state.activeProgramItem].batchCode;

            let quizFormData = {
                "schedule_date": this.state.cloneQuizForm['startDate'].value,
                "schedule_time": this.state.cloneQuizForm['startTime'].value,
                "due_date": this.state.cloneQuizForm['dueDate'].value,
                "due_time": this.state.cloneQuizForm['dueTime'].value,
                "module_name": moduleName,
                "batch_code": batchCode
            };

            console.log('Final Object Data =>>>', quizFormData)
            this.props.cloneQuiz(this.props.data.id, quizFormData);
        }
    }

    dropdownModuleItemClicked = (pos) => {
        this.setState({ activeModuleItem: pos });
    }

    dropdownProgramItemClicked = (pos) => {
        this.setState({ activeProgramItem: pos, showLoader: false, moduleList: [{ name: 'Loading Modules...' }] });
        const batchCode = this.state.programList[pos].batchCode;
        this.getPMProgramModulesList(batchCode);
    }

    getPMProgramModulesList = (batchCode) => {
        this.setState({ isModulesFetched: false })
        ResourceAPIController.getPMProgramModulesList(batchCode)
            .then(response => {
                let responseObj = response.result;

                this.setState({
                    moduleList: responseObj.modulesList,
                    activeModuleItem: 0,
                    showLoader: false,
                    isModulesFetched: true,
                });
            })
            .catch(err => {
                console.log('[PM Clone Quiz Form ] getPMProgramModulesList Error => ', err)
                this.setState({ showLoader: false });
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                } else {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                this.props.closePopup('');
            });
    }

    getPMProgramsList = () => {
        ResourceAPIController.getPMProgramsListInstructor()
            .then(response => {
                let responseObj = response.result;
                let programList = [];
                for (let i = 0; i < responseObj.programsList.length; i++) {
                    programList[i] = {
                        "id": i + 1,
                        "name": responseObj.programsList[i].batchCode,
                        "batchCode": responseObj.programsList[i].batchCode
                    }
                }
                this.setState({
                    programList: programList,
                    moduleList: responseObj.modulesList,
                    showLoader: false
                });
            })
            .catch(err => {
                console.log('[PM Clone Quiz Form ] getPMProgramsList Error => ', err)
                this.setState({ showLoader: false });
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                } else {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                this.props.closePopup('');
            });
    }

    setFormData = () => {
        let updatedForm = { ...this.state.cloneQuizForm };

        let quizData = !IsObjectEmpty(this.props.data) ? this.props.data : {};
        if (!IsObjectEmpty(quizData)) {

            let quizName = '', passMarks = '', startDate = '', startTime = '', dueDate = '', dueTime = '', timeLimit = '';

            quizName = !IsStringEmpty(quizData.title) ? quizData.title : '';
            startDate = !IsStringEmpty(quizData.startDate) ? parseDateForInputField(new Date(quizData.startDate)) : '';
            dueDate = !IsStringEmpty(quizData.dueDate) ? parseDateForInputField(new Date(quizData.dueDate)) : '';
            startTime = !IsStringEmpty(quizData.startTime) ? parseTimeForInputField(quizData.startTime) : '';
            dueTime = !IsStringEmpty(quizData.dueTime) ? parseTimeForInputField(quizData.dueTime) : '';

            updatedForm['quizTitle'].value = quizName;
            updatedForm['quizTitle'].disabled = true;
            updatedForm['startDate'].value = startDate;
            updatedForm['startTime'].value = startTime;
            updatedForm['dueDate'].value = dueDate;
            updatedForm['dueTime'].value = dueTime;

            this.setState({ cloneQuizForm: updatedForm });
        }
    }

    componentDidMount() {
        this.setFormData();

        this.getPMProgramsList();
    }

    inputFieldQuiz = (key) => {
        return <Input
            inputIdentifier={key}
            elementType={this.state.cloneQuizForm[key].elementType}
            elementConfig={this.state.cloneQuizForm[key].elementConfig}
            label={this.state.cloneQuizForm[key].label}
            value={this.state.cloneQuizForm[key].value}
            disabled={this.state.cloneQuizForm[key].disabled}
            options={this.state.cloneQuizForm[key].options}
            changed={(event) => this.inputChangedHandler(event, key)}
            touched={this.state.cloneQuizForm[key].touched}
            afterText={this.state.cloneQuizForm[key].remainingChar}
            dropdownOpen={this.state.cloneQuizForm[key].dropdownOpen}
            onDropDownClick={() => this.onDropDownClick(key)}
            onDropDownItemClick={this.onDropDownItemClick}
            required={!IsObjectEmpty(this.state.cloneQuizForm[key].validation) ? (!IsObjectEmpty(this.state.cloneQuizForm[key].validation.required) ? this.state.cloneQuizForm[key].validation.required.value : false) : false}
            showError={(!this.state.cloneQuizFormValid && !this.state.cloneQuizForm[key].valid) ? true : false}
            error={this.state.cloneQuizForm[key].errorMessage}
        // disableDates={true}
        // disableDateValue={{ minDate: minDate, maxDate: maxDate }}
        />
    }

    render() {
        return (
            <FlexModal visible={true} fullScreenMobile={true} backdropClicked={() => this.props.closePopup('')}>
                <div className={classes.CreateQuizFormContainer}>
                    <div className={classes.CloseIcon}>
                        <IconButton
                            styleclass='NoBorder SmallIcon'
                            icon={closeIconBlack}
                            altText='Close Icon'
                            clicked={() => this.props.closePopup('')}
                        />
                    </div>
                    <h3 className={classes.PopupHeading}>
                        Clone Quiz
                    </h3>

                    {this.props.showLoader || this.state.showLoader
                        ? <div className={classes.FormLoaderContainer}>
                            <ShowLoader isLoading={this.props.showLoader || this.state.showLoader} transparentBg={true} />
                        </div>
                        : <Wrapper>
                            <div className={classes.FormInput}>
                                {this.inputFieldQuiz('quizTitle')}
                            </div>
                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                {this.inputFieldQuiz('startDate')}
                            </div>
                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                {this.inputFieldQuiz('startTime')}
                            </div>
                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                {this.inputFieldQuiz('dueDate')}
                            </div>
                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                {this.inputFieldQuiz('dueTime')}
                            </div>

                            <div className={classes.ProgramSection}>
                                <div className={classes.ProgramInfo}>
                                    <NewInputDropDown
                                        forFormPage={true}
                                        dropdownItemsList={this.state.programList}
                                        activeItemPos={this.state.activeProgramItem}
                                        dropdownItemClicked={this.dropdownProgramItemClicked}
                                        title={"Select Program"}
                                        width={classes.Width}
                                        multiple={false}
                                        id="program"
                                        showBatchCode={true}
                                        module={true}
                                        reduceTopMargin={true}
                                    />

                                    <NewInputDropDown
                                        forFormPage={true}
                                        dropdownItemsList={this.state.moduleList}
                                        activeItemPos={this.state.activeModuleItem}
                                        dropdownItemClicked={this.dropdownModuleItemClicked}
                                        title={"Select Module"}
                                        width={classes.Width}
                                        img={'TechLogo'}
                                        id="module"
                                        module={true}
                                        reduceTopMargin={true}
                                        isModulesFetched={this.state.isModulesFetched}
                                    />
                                </div>
                            </div>

                            {
                                this.state.showFormErrorMessage
                                    ? <p className={classes.ErrorText}>{this.state.formErrorMessage}</p> : null
                            }


                            <div className={classes.ButtonContainer}>
                                <Button
                                    styleclass="NonMobileOnly"
                                    label={"CLONE QUIZ"}
                                    clicked={this.onCloneQuizButtonClick}
                                    disabled={false}
                                    tooltip={null}
                                    margin="16px 20px 20px 0px"
                                />
                                <Button
                                    styleclass="MobileOnly"
                                    label={"CLONE QUIZ"}
                                    clicked={this.onCloneQuizButtonClick}
                                    disabled={false}
                                    tooltip={null}
                                    margin="0px"
                                    padding="1em 2em"
                                    fontSize="0.625em"
                                />
                            </div>
                        </Wrapper>
                    }
                </div>
            </FlexModal >
        );
    }
}

export default CloneQuizForm;